import intl from "react-intl-universal";
import { TbFlask } from "react-icons/tb";
import { useBaasInstance } from "../../../../Contexts/BaasInstanceContext";
import { isBaasHmlInstance } from "../../../../Services/baasInstancesApi";

/**
 * Stripe-style sandbox strip when the selected instance is HML / homologation.
 * Warm peach/amber bar (Stripe sandbox parity). Distinct from the stronger
 * amber "Visualizar como" banner — HML stacks first when both are active.
 * Full-bleed / sticky chrome is owned by BaasConsoleChrome when flush.
 */
export const BaasHmlEnvBanner = ({ flush = false }) => {
  const { selectedInstance } = useBaasInstance();

  if (!isBaasHmlInstance(selectedInstance)) return null;

  const layoutClass = flush
    ? "baas-hml-env-banner flex items-center gap-3 border-b border-orange-400/90 bg-orange-300 px-4 py-2.5 text-sm text-orange-950 shadow-sm dark:border-orange-500 dark:bg-orange-400 dark:text-orange-950 md:px-5 lg:px-8"
    : "baas-hml-env-banner sticky top-0 z-30 -mx-4 flex items-center gap-3 border-b border-orange-400/90 bg-orange-300 px-4 py-2.5 text-sm text-orange-950 shadow-sm dark:border-orange-500 dark:bg-orange-400 dark:text-orange-950 md:-mx-5 md:px-5 lg:-mx-8 lg:px-8";

  return (
    <div className={layoutClass} role="status" aria-live="polite">
      <TbFlask className="h-5 w-5 shrink-0 opacity-90" aria-hidden />
      <p className="min-w-0 flex-1 font-medium leading-snug">
        {intl.get("baas.instances.environment.hmlBanner")}
      </p>
      <span className="hidden shrink-0 rounded-md bg-orange-950/15 px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide text-orange-950 sm:inline">
        {intl.get("baas.instances.environment.hmlBadge")}
      </span>
    </div>
  );
};
